export class Callout {
  ID: number;
  ProgramVisibility: string | null;
  Heading: string;
  Text: string;
  Url: string;
  UrlTarget: string;
  ButtonText: string;
  ModalName?: string;
  Image?: string;

  constructor(
    ID?: number,
    ProgramVisibility?: string | null,
    Heading?: string,
    Text?: string,
    Url?: string,
    UrlTarget?: string,
    ButtonText?: string,
    ModalName?: string,
    Image?: string
 ) {
    this.ID = ID;
    this.ProgramVisibility = ProgramVisibility;
    this.Heading = Heading;
    this.Text = Text;
    this.Url = Url;
    this.UrlTarget = UrlTarget;
    this.ButtonText = ButtonText;
    this.ModalName = ModalName;
    this.Image = Image;
  }
}
